// eslint-disable-next-line flowtype/require-valid-file-annotation
import { v1 } from 'uuid';
import ensureUrl from './ensureUrl';

/**
 * We configure how jsnlogger will send logs to the server.
 *
 * @param {JL} JL The JsnlJs library instance
 * @param {String} bffUrl The loggingEndpoint
 * @return {Void} No return value
 */
const configureJsnlog = (JL: any, bffUrl: string) => {
  const url = `${ensureUrl(bffUrl)}jsnlog.logger`;

  /**
    It has an internal buffer that stores at most 20 log messages;
    Log messages with severity smaller than 1000 (TRACE) are ignored.
    Log messages with severity equal or greater than 1000 (TRACE) and lower than 4000 (WARN) are stored in the internal buffer, but not sent to the server;
    Log messages with severity equal or greater than 4000 (WARN) and lower than 6000 (FATAL) are sent to the server on their own;
    Log messages with severity equal or greater than 6000 (FATAL) are sent to the server, along with all messages stored in the internal buffer.
  */
  const errorLogAppender = JL.createAjaxAppender('icisAppender');
  errorLogAppender.setOptions({
    url,
    bufferSize: 20,
    storeInBufferLevel: 1000,
    level: 4000,
    sendWithBufferLevel: 6000,
    disallow: /Telemetry Log|FMP Log/,
  });

  /**
    - Send 10 log messages in one go, rather than one by one
    - Send batched messages every 15 seconds if batch size not reached
    - When the server is unreachable and log messages are being stored until it is reachable again,
      100 is the maximum number of messages that will be stored.
   */
  const telemetryLogAppender = JL.createAjaxAppender('icisTelemetryAppender');
  telemetryLogAppender.setOptions({
    url,
    batchSize: 10,
    batchTimeout: 15000,
    maxBatchSize: 100,
    disallow: /^((?!Telemetry Log).)*$/,
  });

  /**
    - Send 10 log messages in one go, rather than one by one
    - Send batched messages every 15 seconds if batch size not reached
    - When the server is unreachable and log messages are being stored until it is reachable again,
      100 is the maximum number of messages that will be stored.
   */
  const firstMeaningfulPaintLogAppender = JL.createAjaxAppender('firstMeaningfulPaintLogAppender');
  firstMeaningfulPaintLogAppender.setOptions({
    url,
    batchSize: 10,
    batchTimeout: 15000,
    maxBatchSize: 100,
    disallow: /^((?!FMP Log).)*$/,
  });

  JL().setOptions({
    appenders: [errorLogAppender, telemetryLogAppender, firstMeaningfulPaintLogAppender],
    requestId: v1(), // allow us to track all logs from a single app instance
  });

  return { errorLogAppender, telemetryLogAppender, firstMeaningfulPaintLogAppender };
};

export default configureJsnlog;
